import React from 'react';
import styles from './Footer.module.css';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.column}>
          <h3>Produsele și serviciile noastre</h3>
          <ul className={styles.links}>
            <li><NavLink to="/about">Despre noi</NavLink></li>
            <li><NavLink to="/shop">Produse</NavLink></li>
            <li><NavLink to="/contact">Contacte</NavLink></li>
          </ul>
        </div>
        <div className={styles.column}>
          <h3>Contact rapid</h3>
          <div className={styles.contactList}>
            <div className={styles.contactItem}>
              <p className={styles.location}>București</p>
              <a href="tel:+40748556699" className={styles.phone}>
                + 40 748 55 66 99
              </a>
            </div>
            <div className={styles.contactItem}>
              <p className={styles.location}>Galați</p>
              <a href="tel:+40757994455" className={styles.phone}>
                + 40 757 99 44 55
              </a>
            </div>
          </div>
        </div>
        <div className={styles.column}>
          <p className={styles.description}>Altep - suntem o echipă de oameni pasionați, al căror scop este de a îmbunătăți viața la toată lumea prin produse provocatoare.</p>
          <div className={styles.socialIcons}>
            <a target="_blank" href="https://www.facebook.com/profile.php?id=61569245610714" className={`${styles.icon} ${styles.facebookColor}`}><i className="fa-brands fa-facebook-f"></i></a>
            <a target="_blank" href="https://twitter.com/intent/tweet?text=Catalog%20de%20produc%C8%9Bie%20%7C%20ALTEP%20Romania&amp;url=https%3A%2F%2Faltep.ro%2F" className={`${styles.icon} ${styles.twitterColor}`}><i className="fa-brands fa-twitter"></i></a>
            <a target="_blank" href="http://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A%2F%2Faltep.ro%2F&amp;title=Catalog%20de%20produc%C8%9Bie%20%7C%20ALTEP%20Romania&amp;" className={`${styles.icon} ${styles.linkedinColor}`}><i className="fa-brands fa-linkedin-in"></i></a>
            <a target="_blank" href="mailto:?body=https%3A%2F%2Faltep.ro%2F&amp;subject=Catalog%20de%20produc%C8%9Bie%20%7C%20ALTEP%20Romania" className={`${styles.icon} ${styles.mailColor}`}><i className="fa-regular fa-envelope"></i></a>
            <a target="_blank" href="https://www.facebook.com/profile.php?id=61569245610714" className={`${styles.icon}`}><i className="fa-brands fa-tiktok"></i></a>
          </div>
        </div>
      </div>
      <div>
        <p className={styles.copyright}>Copyright © Altep</p>
      </div>
    </footer>
  );
};

export default Footer;
